import React from "react";

const RequirementContext = React.createContext({});

export default RequirementContext;
